import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => ({
    url: state.customMeetYourHerbsReducer?.productData?.canonicalUrl
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface GAIAMYHShopThisProductStyles {
    mainWrapper?: InjectableCss;
    readyToPurchaseText?: TypographyProps;
    shopNowBtn?: ButtonPresentationProps;
}
const styles: GAIAMYHShopThisProductStyles = {
    mainWrapper: {
        css: css`
            width: 100%;
            display: flex;
            padding-top: 34px;
            border-radius: 10px;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 23px;
                    `,
                    css`
                        padding-top: 23px;
                    `,
                    css`
                        padding-top: 28px;
                    `,
                    css`
                        padding-top: 28px;
                    `,
                    css``,
                ])}
        `,
    },
};



const GAIAMYHShopThisProduct: React.FC<Props> = ({ url, history }) => {
    const redirectToShopUrl = () => {
        if (url) {
            history.push(url)
        }
    }
    return (
        <StyledWrapper {...styles.mainWrapper}>
            <Button onClick={redirectToShopUrl} {...styles.shopNowBtn}>Shop This Product</Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(GAIAMYHShopThisProduct)),
    definition: {
        displayName: "MYH Shop This Product",
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
